import { boolean, object } from 'zod';

export const EmailRequiredConstraintSchema = object({
  isEnabled: boolean(),
});
